export const API_KEY = "LDLZD5U6GVYWG8UCB7MTZ84ZL";
export const UNITS = "metric";
export const WEATHER_URL =
  "https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/";
export const TIMEOUT_SEC = 10;
